export class StringTool {

  static capitalizeFirstLetter(string) {
    return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
  }

  static uncapitalizeFirstLetter(string) {
    return `${string.charAt(0).toLowerCase()}${string.slice(1)}`;
  }

  static isNotNullOrEmpty(string) {
    return string && string !== undefined && string !== '';
  }
}
